import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const Ctx = createContext(null);
const read = (key, fallback) => {
  try {
    return JSON.parse(localStorage.getItem(key)) ?? fallback;
  } catch {
    return fallback;
  }
};

export const NewsStoreProvider = ({ children }) => {
  const [later, setLater] = useState(() => read("gtc:readLater", {}));
  const [searches, setSearches] = useState(() => read("gtc:savedSearches", []));
  useEffect(() => { localStorage.setItem("gtc:readLater", JSON.stringify(later)); }, [later]);
  useEffect(() => { localStorage.setItem("gtc:savedSearches", JSON.stringify(searches)); }, [searches]);

  const toggleLater = useCallback((item) => setLater((m) => {
    const next = { ...m };
    if (next[item.id]) delete next[item.id];
    else next[item.id] = { ...item, saved_at: new Date().toISOString() };
    return next;
  }), []);
  const saveSearch = useCallback((name, params) => setSearches((s) => [{ id: Date.now().toString(36), name, params }, ...s].slice(0, 20)), []);
  const removeSearch = useCallback((id) => setSearches((s) => s.filter((x) => x.id !== id)), []);

  const value = useMemo(() => ({
    later: Object.values(later).sort((a, b) => b.saved_at.localeCompare(a.saved_at)),
    isLater: (id) => Boolean(later[id]), toggleLater, searches, saveSearch, removeSearch,
  }), [later, searches, toggleLater, saveSearch, removeSearch]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useNewsStore = () => useContext(Ctx);
